var trackListReducer = function (state, action) {
    if (state === void 0) { state = { channelId: '', ids: [] }; }
    switch (action.type) {
        case 'CHANGE_EXPANDED_TRACK_LIST': {
            return action.payload;
        }
        default: {
            return state;
        }
    }
};
export default trackListReducer;



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/trackslist.reducer.ts
// module id = 1489
// module chunks = 81